import { render, staticRenderFns } from "./PaymentStatusTrigger.vue?vue&type=template&id=48a0b2b9&"
import script from "./PaymentStatusTrigger.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports